module.exports = "<div ui-view></div>"


/*****************
 ** WEBPACK FOOTER
 ** ../~/noop-loader!./components/xo-wallet-components/src/add-bank/template.html
 ** module id = 251
 ** module chunks = 1
 **/